import React, { useState } from 'react'

export function ImageWithFallback({ src, fallback, alt, ...props }) {
  const [imgSrc, setImgSrc] = useState(src)

  // Handles the image loading error
  const handleError = () => {
    setImgSrc(fallback)
  }

  return (
    <img
      src={imgSrc || fallback}
      alt={alt}
      onError={handleError}
      {...props}
      style={{ maxWidth: '100%', ...props.style }}
    />
  )
}
